import { render, staticRenderFns } from "./GerenciamentoDivulgacoes.vue?vue&type=template&id=3891116e&scoped=true"
import script from "./GerenciamentoDivulgacoes.vue?vue&type=script&lang=js"
export * from "./GerenciamentoDivulgacoes.vue?vue&type=script&lang=js"
import style0 from "./GerenciamentoDivulgacoes.vue?vue&type=style&index=0&id=3891116e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3891116e",
  null
  
)

export default component.exports